import React from 'react';
import { TagIcon, FileSpreadsheetIcon, MailIcon } from 'lucide-react';
export function OverwhelmedCreatorMockup() {
  return <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-xl p-8 w-full border-2 border-red-200" data-id="element-498">
            <div className="relative" data-id="element-499">
                {/* Central stressed emoji */}
                <div className="text-center mb-6" data-id="element-500">
                    <div className="text-7xl mb-2" data-id="element-501">😰</div>
                    <p className="text-sm font-semibold text-gray-700" data-id="element-502">
                        Newsletter Creator
                    </p>
                </div>

                {/* Scattered elements around the creator */}
                <div className="space-y-4" data-id="element-503">
                    {/* Tags floating around */}
                    <div className="flex flex-wrap gap-2 justify-center mb-4" data-id="element-504">
                        <div className="bg-white border-2 border-gray-300 rounded-full px-3 py-1 text-xs flex items-center shadow-sm transform -rotate-3" data-id="element-505">
                            <TagIcon className="w-3 h-3 mr-1 text-gray-500" data-id="element-506" />
                            <span className="text-gray-600" data-id="element-507">tag_buyer_2023</span>
                        </div>
                        <div className="bg-white border-2 border-gray-300 rounded-full px-3 py-1 text-xs flex items-center shadow-sm transform rotate-2" data-id="element-508">
                            <TagIcon className="w-3 h-3 mr-1 text-gray-500" data-id="element-509" />
                            <span className="text-gray-600" data-id="element-510">interested_product_a</span>
                        </div>
                        <div className="bg-white border-2 border-gray-300 rounded-full px-3 py-1 text-xs flex items-center shadow-sm transform -rotate-1" data-id="element-511">
                            <TagIcon className="w-3 h-3 mr-1 text-gray-500" data-id="element-512" />
                            <span className="text-gray-600" data-id="element-513">clicked_link_may</span>
                        </div>
                        <div className="bg-white border-2 border-gray-300 rounded-full px-3 py-1 text-xs flex items-center shadow-sm transform rotate-3" data-id="element-514">
                            <TagIcon className="w-3 h-3 mr-1 text-gray-500" data-id="element-515" />
                            <span className="text-gray-600" data-id="element-516">segment_xyz</span>
                        </div>
                    </div>

                    {/* Spreadsheet mockup */}
                    <div className="bg-white rounded-lg border-2 border-gray-300 p-4 shadow-md transform -rotate-1" data-id="element-517">
                        <div className="flex items-center mb-2" data-id="element-518">
                            <FileSpreadsheetIcon className="w-4 h-4 text-green-600 mr-2" data-id="element-519" />
                            <span className="text-xs font-semibold text-gray-700" data-id="element-520">
                                subscriber_tags_final_v3.csv
                            </span>
                        </div>
                        <div className="space-y-1" data-id="element-521">
                            <div className="grid grid-cols-3 gap-2 text-xs" data-id="element-522">
                                <div className="bg-gray-100 p-1 font-semibold text-gray-600" data-id="element-523">
                                    Email
                                </div>
                                <div className="bg-gray-100 p-1 font-semibold text-gray-600" data-id="element-524">
                                    Tag1
                                </div>
                                <div className="bg-gray-100 p-1 font-semibold text-gray-600" data-id="element-525">
                                    Tag2
                                </div>
                            </div>
                            <div className="grid grid-cols-3 gap-2 text-xs text-gray-500" data-id="element-526">
                                <div className="p-1 truncate" data-id="element-527">user@email.com</div>
                                <div className="p-1" data-id="element-528">???</div>
                                <div className="p-1" data-id="element-529">???</div>
                            </div>
                            <div className="grid grid-cols-3 gap-2 text-xs text-gray-500" data-id="element-530">
                                <div className="p-1 truncate" data-id="element-531">another@email.com</div>
                                <div className="p-1" data-id="element-532">???</div>
                                <div className="p-1" data-id="element-533">???</div>
                            </div>
                        </div>
                    </div>

                    {/* Generic blast email mockup */}
                    <div className="bg-white rounded-lg border-2 border-gray-300 p-4 shadow-md transform rotate-2" data-id="element-534">
                        <div className="flex items-center mb-3" data-id="element-535">
                            <MailIcon className="w-4 h-4 text-blue-600 mr-2" data-id="element-536" />
                            <span className="text-xs font-semibold text-gray-700" data-id="element-537">
                                Generic Blast Email
                            </span>
                        </div>
                        <div className="space-y-2" data-id="element-538">
                            <div className="text-xs font-semibold text-gray-800" data-id="element-539">
                                Subject: Weekly Newsletter
                            </div>
                            <div className="text-xs text-gray-600 leading-relaxed" data-id="element-540">
                                <p className="mb-1" data-id="element-541">Hi Everyone,</p>
                                <p className="mb-1" data-id="element-542">
                                    Here's this week's content for ALL subscribers...
                                </p>
                                <p className="text-gray-400 italic" data-id="element-543">
                                    Same message • Same offers • No personalization
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom text */}
                <div className="mt-6 text-center" data-id="element-544">
                    <p className="text-sm font-semibold text-red-700" data-id="element-545">
                        Manual tagging chaos
                    </p>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-546">
                        Hours wasted • Generic content • Lost revenue
                    </p>
                </div>
            </div>
        </div>;
}